import axios from "axios";
import config from "./config.json";
const http = axios.create({
    baseURL: config.baseUrl,
    headers: {
        "X-Requested-with": "XMLHttpRequest",
    },
    withCredentials: true,
});
export default http;
